export const STORAGE_KEYS=Object.freeze({
  SOUND:'nsr_sound',
  MOTION:'nsr_v04_motion',
  JAR:'nsr_v04_marks',
  JAR_RECOVERY:'nsr_v04_marks_recovery',
  MVD:'nsr_v06_mvd',
  MVD_STEP:'nsr_v08_mvd_step',
  PARKING_LOT:'nsr_parking_lot_v1',
  GOAL_FILTER:'nsr_goal_filter_v1',
  FOCUS_TIMER:'nsr_focus_timer_v1',
  NEXT_STEP:'nsr_next_step_v1',
  SHREDDER:'nsr_shredder_v1',
  SHREDDER_DRAFT:'nsr_shredder_draft_v1',
  THREAD:'nsr_return_note_v1',
  TODAY:'nsr_today_floor_v1',
  WELCOME:'nsr_welcome_v1',
  RECOVERY:'nsr_recovery_v1'
});

const invalidKeys=new Set();
export function markInvalid(key){invalidKeys.add(key)}
export function read(key,fallback=null){
  try{return localStorage.getItem(key)??fallback}catch{return fallback}
}

export function write(key,value){
  try{localStorage.setItem(key,value);invalidKeys.delete(key);return true}catch{dispatchEvent(new CustomEvent('nsr-storage-error'));return false}
}

export function readJSON(key,fallback){
  if(invalidKeys.has(key))return structuredClone(fallback);
  const raw=read(key);
  if(raw===null)return structuredClone(fallback);
  try{return JSON.parse(raw)}catch{
    preserveRecovery(key,raw);return structuredClone(fallback);
  }
}

export function preserveRecovery(key,raw){
  try{const previous=JSON.parse(localStorage.getItem(STORAGE_KEYS.RECOVERY)||'{}');if(!previous[key]){previous[key]={raw,at:new Date().toISOString()};localStorage.setItem(STORAGE_KEYS.RECOVERY,JSON.stringify(previous))}}catch{}
}

export function writeJSON(key,value){return write(key,JSON.stringify(value))}
